var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Select",
    {
      attrs: {
        value: _vm.value,
        "allow-clear": "",
        "show-search": "",
        "filter-option": false,
        loading: _vm.loading,
        disabled: _vm.disabled,
        "dropdown-match-select-width": false,
        options: _vm.options,
        "label-in-value": _vm.labelInValue,
        "option-label-prop": "label"
      },
      on: { search: _vm.onSearch, change: _vm.onChange }
    },
    [
      _vm._t(
        "default",
        function() {
          return _vm._l(_vm.options, function(option) {
            return _c(
              "a-select-option",
              {
                key: option.key,
                attrs: { value: option.value, label: option.label }
              },
              [
                _vm._t(
                  "option",
                  function() {
                    return [
                      _c("a-tooltip", [
                        _c(
                          "span",
                          { attrs: { slot: "title" }, slot: "title" },
                          [_vm._v(" " + _vm._s(option.label) + " ")]
                        ),
                        _vm._v(" " + _vm._s(option.label) + " ")
                      ])
                    ]
                  },
                  { option: option }
                )
              ],
              2
            )
          })
        },
        { options: _vm.options }
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }